import postLoginUrl from "@adapters/infrastructures/urlConfig/PostLogin/PostLoginUrl";
import { IndexDetailsMapper } from "@domains/features/PostLogin/mapper/IndexDetailsMapper";
import { NetPositionsMapper } from "@domains/features/PostLogin/mapper/NetPositionsMapper";
class PostLoginRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getNFOLive() {
        const url = new URL(postLoginUrl.nfoLive);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async getNetPositions() {
        const url = new URL(postLoginUrl.positions + `/${await this.accountDetails.getUserID()}`);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return NetPositionsMapper(result);
    }
    async saveIndicesData(req) {
        const url = new URL(postLoginUrl.saveIndices);
        const result = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return result.data;
    }
    async portfolioCompositionData(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(postLoginUrl.portfolioComposition);
        url.searchParams.append("accountId", accountCode);
        url.searchParams.append("type", req.type);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result;
    }
    async getContributionData(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(postLoginUrl.contribution);
        url.searchParams.append("accountId", accountCode);
        url.searchParams.append("type", req.type);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async getIndexDetails() {
        const url = new URL(postLoginUrl.indexList);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return IndexDetailsMapper(result.data);
    }
    async getMarketMapPL(req) {
        const url = new URL(postLoginUrl.marketMapPostLogin);
        const accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountId", accountCode);
        url.searchParams.append("investmentType", req.investmentType);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async exploreTrading() {
        const url = new URL(postLoginUrl.exploreTrade);
        const result = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
        });
        return result.data;
    }
    async getServiceList(req) {
        const url = new URL(postLoginUrl.serviceList);
        url.searchParams.append("accTyp", req.accTyp);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async getDiversifyPortfolio() {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(postLoginUrl.diversifyPortfolio);
        url.searchParams.append("accountId", accountCode);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async getAllIndicesList() {
        const url = new URL(postLoginUrl.allIndicesList);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async getUpcomingEvents() {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(postLoginUrl.upcomingEvents);
        url.searchParams.append("accountId", accountCode);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
}
export default PostLoginRepository;
